export var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "admin";
    UserRole["Developer"] = "developer";
    UserRole["Moderator"] = "moderator";
    UserRole["System"] = "system";
    UserRole["User"] = "user";
})(UserRole || (UserRole = {}));
//# sourceMappingURL=user-role.const.js.map